// extracted by mini-css-extract-plugin
export default {"select":"select-header-theme__select","arrow":"select-header-theme__arrow","arrowDown":"select-header-theme__arrowDown"};